import { ReactComponent as Edit } from "./Edit.svg";
import { ReactComponent as Good } from "./Good.svg";
import { ReactComponent as Normal } from "./Normal.svg";
import { ReactComponent as Bad } from "./Bad.svg";
import { ReactComponent as Logo } from "./Logo.svg";
import { ReactComponent as MainLogo } from "./MainLogo.svg";
import { ReactComponent as MiniLogo } from "./MiniLogo.svg";
import { ReactComponent as QRCode } from "./QRCode.svg";

const Icons = {
  Edit: Edit,
  Good: Good,
  Normal: Normal,
  Bad: Bad,
  Logo: Logo,
  MainLogo: MainLogo,
  MiniLogo: MiniLogo,
  QRCode: QRCode,
};

export default Icons;
